import React from 'react';

export const PlayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="100" height="100" fill="currentColor" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M26 100V0L86 50L26 100Z" />
  </svg>
);
